import React, { Component, useState } from "react";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import "./style.scss";
import { BackgroundImage } from "../../elements";
import classNames from "classnames";
import Modal from "../../components/Modal";
import Image from "../../elements/image";
import Input from "../../elements/input";
import { FilterDropdown, Dropdown } from "../../elements";
import Checkbox from "../../elements/checkbox";
import Heading from "../../elements/heading";
import { withRouter } from "react-router-dom";
import { apiAsia } from "../../utils/api-asia";
import { mobileIs } from "../../utils/siteUtils";
import { S_LANG, webStorage } from "../../utils/webStorage";
import { gtag } from "../../utils";
import axios from "axios";

// import { appendQuery } from "../../utils/urlHelper";
import SuperButton from "../../elements/super-button";
/**
 * @typedef {Object} CountryListRes
 * @property {String} code
 * @property {CountryListResObj} obj
 *
 * @typedef {Object} CountryListResObj
 * @property {Country} regions
 *
 * @typedef {Object} SiteRes
 * @property {String} CountryLocal
 * @property {String} CountryLanguage
 * @property {String} CountryOrg
 * @property {String} CountryleadsLang
 */
class Newsletter extends Component {
  constructor(props, context) {
    super(props, context);
    const model = this.props;
    const { submitted, hasError, errorMessage } = this.props;
    const { fields } = model;
    const { emailTipText, defaultCountry, emailErrorTipText, countryTipText, language, areaCode } = fields;
    const lang = language?.fields?.phrase?.value ? language?.fields?.phrase?.value : 'en';
    this.state = {
      submitted: submitted && submitted ? submitted.status : false,
      emailTipText: emailTipText.value || "",
      defaultCountry: defaultCountry.value || "",
      countryVisible: false,
      hasError: hasError || false,
      errorMessage: errorMessage || null,
      email: null,
      lang: lang,
      areaCode: areaCode?.value,
      emailIsValid: true,
      emailEnteredShowError: false,
      emailWarningMessage: emailErrorTipText.value || "",
      showForm: true,
      country: null,
      countryShowError: false,
      countryWarningMessage: countryTipText.value || "",
      agreedToNewsletter: false,
      countries: [],
      modalDate: {
        showModal: true,
        nestedGrid: true,
        id: "newsletter"
      }
    };
    webStorage.set(S_LANG, lang);
  }
  componentDidMount(props) {
    const model = this.props;
      apiAsia.form.country({language: this.state.lang, areaCode: this.state.areaCode}).then(res => {
        if (!!res[0]) {
          let countrtList = []
          let codeList = []
          res[0].forEach(v=>{
            countrtList.push({
              code : v.countryCode,
              value : v.countryName
            })
          })
          codeList.push({
            code:'editSelect',
            value: 'Other',
          })
          this.setState({
            countries: countrtList
          });
					getCountryCode(countrtList);
        }
      })
      .catch(err => {
        console.log(err)
      });

      this.setState({
        countryVisible: true
      });
			
			const getCountryCode = async (countrtList) => {
			  const [res, ex] = await apiAsia.dealer.getCountryCode({});
				console.log(res)
			  if(countrtList && countrtList.length > 0) {
			    countrtList.forEach((item, index) => {
			      if(item.code === res.countryCode) {
			        this.setState({
								country: item
							})
			      }
			    })
			  }
			}
  }
  onInputChange(evt, isValid) {
    const { fields } = this.props;
    const email = evt.target.value;

    this.setState({
      hasError: false,
      errorMessage: null,
      email: email
    });
    this.submitting = false;
  }
  onInputBlur(evt, isValid) {
    const { fields } = this.props;
    const email = evt.target.value;
    let emailEnteredShowErrorValue = email ? !isValid : false;
    this.setState({
      emailIsValid: isValid,
      emailEnteredShowError: emailEnteredShowErrorValue,
      emailWarningMessage: isValid ? null : fields.emailErrorTipText.value
    });
  }
  onDropdownChange(value) {
    const { fields } = this.props;
    this.setState({
      hasError: false,
      errorMessage: null,
      country: value,
      defaultCountry: !value ? fields.countryTipText.value : fields.defaultCountry.value
    });
  }

  onCheckmarkChange(value) {
    this.setState({
      hasError: false,
      showCheckboxError: false,
      errorMessage: null,
      agreedToNewsletter: value
    });
  }
  async onSubmit() {
    if (!this.submitting) {
      let lang = this.state.lang?.toLowerCase();
      webStorage.set(S_LANG, lang);
      const { fields, page } = this.props;
      const { emailEmptyTipText, emailErrorTipText, countryTipText, repeatSubmitErrorTipText, submitErrorTipText, CtaName } = fields;
      const { email, emailIsValid, country, agreedToNewsletter, countryVisible } = this.state;
      if (email && emailIsValid && (country || !countryVisible) && agreedToNewsletter) {
        this.submitting = true;
        let body = {
          "Email": email,
          "CountryCode": country.code,
					"Language": lang
        };

        apiAsia.form.submit(null, body).then(res => {
          if(res && res[1]) {
            if (res[1].code === 200) {
              this.setState({
                showForm: false
              });
              gtag('event', 'Component_info', {
                'component_name': 'NewsLetter',
                'page_title': page?.name
              });
            } else if(res[1].code === -100) {
              this.setState({
                emailEnteredShowError: true,
                emailWarningMessage: repeatSubmitErrorTipText.value
              });
            } else if(res[1].code === -101) {
              this.setState({
               errorMessage: emailErrorTipText?.value,
                hasError: true
              });
            } else {
             this.setState({
               errorMessage: submitErrorTipText?.value,
               hasError: true
             });
            }
          }
        })
        .catch(err => {
          console.log(err)
        });
      } else {
        if (!agreedToNewsletter) {
          this.setState({
            showCheckboxError: true
          });
        }
        if (!email) {
          this.setState({
            emailEnteredShowError: true,
            emailWarningMessage: emailEmptyTipText.value
          });
        } else if (!emailIsValid) {
          this.setState({
            emailEnteredShowError: true,
            emailWarningMessage: emailErrorTipText.value
          });
        }
        if (!country && countryVisible) {
          this.setState({
            countryShowError: true,
            countryWarningMessage: countryTipText.value
          });
        }
        if (country?.code === 'default') {
          this.setState({
            countryShowError: true,
            countryWarningMessage: countryTipText.value
          });
        };
      }
    }
  }
  componentWillUnmount() { }

  newsletter(model) {
    const { fields } = model;
    const isMobile = mobileIs()
    const { showForm } = this.state;
    const { paddingAboveTop, paddingAboveBottom, colorScheme, image, CtaName, ctatype, iconName, mandatoryText, FormBody, pcTitle, mTitle, pcSubtitle, mSubtitle, success_icon, pc_success_title, m_success_title, pc_success_subtitle, m_success_subtitle } = fields;
    let { emailTipText, emailWarningMessage, emailEnteredShowError, defaultCountry, countries, countryShowError, countryWarningMessage, showCheckboxError, errorMessage, hasError, countryVisible, country } = this.state;
		if (CtaName) {
      fields.button = {
        ctatype: ctatype,
        colorScheme: colorScheme,
        iconName: iconName,
        link: {
          value: {
            text: CtaName.value
          }
        },
        isShowModal: {
          value: false
        },
        isDisabled: {
          value: false
        },
        callback: () => this.onSubmit()
      };
    }
    let top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "default",
      bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "default";
    const newsletterClasses = classNames("padding-top-" + top, "padding-bottom-" + bottom, `newsletter ${colorScheme ? colorScheme.fields.phrase.value : ""}`, {
      media: image && image.value && image.value.src,
      "grid-story": true,
    }),
      titleMainClasses = "title__main",
      titleSubClasses = "title__sub",
      infoClasses = classNames("info"),
      emailClasses = classNames("email"),
      countryClasses = classNames("country"),
      consentClasses = classNames("consent"),
      ctaClasses = classNames("cta"),
      mediaClasses = classNames("media");
    let newsletterStyles = {};
    const inputProps = {
      label: emailTipText,
      type: "email",
      warningMessage: emailWarningMessage,
      infoMessage: "",
      mandatory: true,
      showError: emailEnteredShowError,
      onChange: (evt, isValid) => this.onInputChange(evt, isValid),
      onFocus: () => {
        this.setState({ emailEnteredShowError: false });
      },
      onBlur: (evt, isValid) => this.onInputBlur(evt, isValid)
    };
    const dropdownProps = {
      placeholder: defaultCountry,
      options: countries,
			selectedOption: country,
      showError: countryShowError,
      warningMessage: countryWarningMessage,
      onChange: value => this.onDropdownChange(value),
      onFocus: () => {
        this.setState({ countryShowError: false });
      }
    };
    const checkboxProps = {
      label: mandatoryText.value,
      // infoText: FormBody.value,
      error: showCheckboxError,
      onChange: value => {
        this.setState({ showCheckboxError: false });
        this.onCheckmarkChange(value);
      },
      onFocus: () => {
        this.setState({ showCheckboxError: false });
      },
      onPrivacyClick(e) {
        // if (e.target.nodeName === "A") {
        //   e.target.href = appendQuery(e.target.href, {
        //     itemId: consent ? consent.id: ""
        //   });
        // }
      }
    };
    return (
      <div className={newsletterClasses} style={newsletterStyles} datasourceid={this.props.rendering.dataSource}>
        {(pcTitle || mTitle) && showForm && (
          <Heading
            {...{
              html: isMobile ? mTitle : pcTitle
            }}
            className={titleMainClasses}
          />
        )}
        {pcSubtitle && pcSubtitle.value && showForm && !isMobile && (
          <div className={infoClasses}>
            <RichText field={pcSubtitle} tag={"p"} />
          </div>
        )}
        {mSubtitle && mSubtitle.value && showForm && isMobile && (
          <div className={infoClasses}>
            <RichText field={mSubtitle} tag={"p"} />
          </div>
        )}
        {showForm && <div className={emailClasses} onClick={this.focus}>
          <Input {...inputProps} />
        </div>}
        {countryVisible && showForm && (
          <div className={countryClasses}>
            <FilterDropdown {...dropdownProps} />
          </div>
        )}
        {showForm && <div className={consentClasses}>
          <Checkbox {...checkboxProps} />
        </div>}
        {errorMessage && showForm && hasError && (
          <div className="error-message">
            <RichText field={{ value: errorMessage }} tag={"p"} />
          </div>
        )}
        {ctatype && showForm && (
          <div className={ctaClasses}>
            <SuperButton {...fields.button} />
          </div>
        )}
        {!showForm && <BackgroundImage {...success_icon} className="success-icon" />}
        {!showForm && isMobile && <RichText field={m_success_title} tag={"div"} className="success-title" />}
        {!showForm && isMobile && <RichText field={m_success_subtitle} tag={"div"} className="success-subtitle" />}
        {!showForm && !isMobile && <RichText field={pc_success_title} tag={"div"} className="success-title" />}
        {!showForm && !isMobile && <RichText field={pc_success_subtitle} tag={"div"} className="success-subtitle" />}
      </div>
    );
  }

  ModelNode(submitted) {
    const model = this.props;
    const { fields } = model;
		return this.newsletter(model);
  }
  render() {
    if (!this.props.fields) return null;
    const model = this.props;
    const { fields } = model;
    const { modalDate, submitted } = this.state;
		return this.ModelNode(submitted);
  }
}
export default withRouter(Newsletter);
